/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Email_SkippedInputs */

const en_task_email_skipped = /** @type {(inputs: Task_Email_SkippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email not sent: this environment does not send email`)
};

const pt_br2_task_email_skipped = /** @type {(inputs: Task_Email_SkippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail não enviado: este ambiente não envia e-mails`)
};

/**
* | output |
* | --- |
* | "Email not sent: this environment does not send email" |
*
* @param {Task_Email_SkippedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_email_skipped = /** @type {((inputs?: Task_Email_SkippedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Email_SkippedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_email_skipped(inputs)
	return pt_br2_task_email_skipped(inputs)
});